import React, {useState} from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import CardColumns from 'react-bootstrap/CardColumns';

function Portfolio(){

  function openPhoto(pic){
    setPhoto(pic)
    setmodalShow(true)
  }

    const[photo, setPhoto] = useState('')
    const[modalShow, setmodalShow] = useState(false)

  const photos = ['./images/1.jpeg', './images/2.png', './images/3.jpg', './images/4.jpg', './images/5.jpg', './images/6.jpeg', './images/7.jpg', './images/8.png', './images/9.png', './images/10.png', './images/11.png', './images/12.png', './images/13.png', './images/14.jpg', './images/15.jpg', './images/16.jpg', './images/17.jpg', './images/18.jpg', './images/19.png', './images/20.jpg', './images/21.jpg', './images/22.jpg', './images/23.jpg']
  return(

    <section id="gallery" style={{marginTop:50}}>
    <Container style={{marginTop:100}}>
    <h1 style={{fontWeight: 'bold', textAlign: 'center', color: '#0116D5'}}>My Gallery</h1>


    <CardColumns style={{marginTop:50}}>

    {photos.length?
    photos.map((p,index)=>{
      return(
        <Card className="p-3" key={index} onClick={()=>openPhoto(p)}>
          <Card.Img variant="top" src={p} style={{cursor: 'pointer'}}/>
        </Card>
      )
    }):null}

</CardColumns>
    </Container>



    <Modal size="lg" show = {modalShow}
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Body>
          <img src={photo}  style={{width: '100%'}}/>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={()=>setmodalShow(false)}>Close</Button>
      </Modal.Footer>
    </Modal>
    </section>

  )}

export default Portfolio;
